import TemplateView from "./TemplateView";
import SimpleListMenu from "./SimpleListMenu";
import messageResource from "./messageResource";

export default class SimpleListMenuButton extends TemplateView {
    constructor({
        itemHtmlCallback = item => "<div></div>",
        emptySelectionMessageKey = null,
        emptyListMessageKey = null,
        extraClass = "",
        menuPositionParams = null,
        menuExtraClass = "",
        autoMenuWidth = true,
        onSelect = item => null,
        itemHeight,
    }) {
        super()
        this.emptySelectionMessageKey = emptySelectionMessageKey;
        this.emptyListMessageKey = emptyListMessageKey;
        this.itemHtmlCallback = itemHtmlCallback;
        this.extraClass = extraClass;
        this.menuExtraClass = menuExtraClass;
        this.menuPositionParams = menuPositionParams
        this.autoMenuWidth = autoMenuWidth;
        this.onSelect = onSelect;
        this.itemHeight = itemHeight
    }

    templateHtml() {
        return "<div class='simpleListMenuButton <%=extraClass%>'>" +
               "  <div class='title'></div>" +
               "  <div class='downIcon'>&nbsp;</div>" +
               "</div>"
    }

    afterRender() {
        this.$title = this.find(".title");

        this.menu = new SimpleListMenu({
            onItemClick: item => {
                this._selectItem(item);
                this.trigger("select", item);
                if (this.onSelect)
                    this.onSelect(item);
            },
            itemHtmlCallback: this.itemHtmlCallback,
            extraClass: this.menuExtraClass,
            itemHeight: this.itemHeight,
            onHide: () => this.$el.removeClass('active'),
            onShow: () => this.$el.addClass('active'),
        }).init(this.$containerEl)

        this.getEl().click(() => {
            if (!this.disabled && this.getItems().length > 0) {
                if (this.autoMenuWidth) {
                    this.menu.getEl().width(this.getEl().width());
                }
                this.menu.showAt(this.getEl(), this.menuPositionParams)
            }
        });

        this.setItems([]);
    }

    getSelectedItem() {
        return this.selectedItem
    }

    getItems() {
        return this.menu.getItems()
    }

    setDisabled(disabled) {
        this.disabled = disabled;
    }

    disableAndHide() {
        this.setDisabled(true);
        this.getMenu().hide();
    }

    setItems(items, selectedItem) {
        this.menu.setItems(items, selectedItem);
        this.$el.toggleClass("empty", items.length === 0);
        this.$el.toggleClass("notEmpty", items.length > 0);
        this.setSelectedItem(selectedItem);
    }

    getMenu() {
        return this.menu;
    }

    setActiveItemByPredicate(itemPredicate = item => {}) {
        this._selectItem(this.getItems().find(itemPredicate))
    }

    setSelectedItem(item) {
        this._selectItem(item)
    }

    _selectItem(item) {
        if (!item) {
            if (this.getItems().length > 0) {
                this.$title.text(this.emptySelectionMessageKey ? messageResource.getMessage(this.emptySelectionMessageKey) : "");
            } else {
                this.$title.text(this.emptyListMessageKey ? messageResource.getMessage(this.emptyListMessageKey) : "");
                this.getEl().addClass("emptyList");
            }
            this.getEl().addClass("emptySelection");
        } else {
            this.$title.html(this.menu.itemHtmlCallback(item));
            this.getEl().removeClass("emptySelection");
            this.menu.selectItem(item)
        }

        this.selectedItem = item;
    }
}


// WEBPACK FOOTER //
// ./web/js/SimpleListMenuButton.js